/*
 * kuvr-cart-truth.js — make the cart page match the real cart. Added 2026-08-23 (BUG-010).
 *
 * WHY: Shopify can serve the /cart PAGE from stale data. Measured on live, same second,
 * one fresh navigation (no cache, no service worker, 129KB transferred): the HTML
 * contained a row for a line item ALREADY REMOVED from the cart, while /cart.js on the
 * same page reported the truth. Even a single render mixed states — subtotal £124.43
 * (fresh) beside data-cart-total-value="37039" (stale) and a badge reading 2.
 *
 * Effects a customer sees without this file: deleted items "come back", ghost rows that
 * cannot be deleted (their line is already gone, so clicking the bin does nothing), and
 * totals that do not match the rows on screen. All of it platform-side — the theme's
 * Liquid renders whatever cart object Shopify hands it.
 *
 * WHAT THIS DOES: /cart.js was fresh in every measured divergence, so treat it as the
 * authority. On cart-page load (and for a short settle window afterwards):
 *   1. fetch /cart.js (cache: no-store)
 *   2. remove any rendered row whose line key is not in the real cart
 *   3. rewrite subtotal, grand total and the header badge from the real numbers
 *   4. if the page is MISSING rows the real cart has, reload once (guarded by a URL
 *      param so a still-stale render cannot cause a loop) — after that, totals are
 *      right even if a row is late.
 *
 * NOT touched: the side/drawer cart (its updates come from cart/change responses, which
 * are consistent), and anything when page and cart already agree — the common case costs
 * one fetch and no DOM writes.
 *
 * 🛑 Remove when Shopify's cart render is trustworthy again — checkable any time by
 * diffing rendered row keys against /cart.js on a burst of add/delete operations.
 */
(function () {
  if (!document.getElementById('main-cart-items')) return; // main cart page only

  var SETTLE_CHECKS = 6;     // re-check over the first ~30s; stale renders settle quickly
  var CHECK_MS = 5000;
  var RELOAD_FLAG = 'kuvr_rc';

  function fmtMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'GBP' })
        .format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function setMoney(sel, cents, currency) {
    document.querySelectorAll(sel + ' .money').forEach(function (el) {
      el.textContent = fmtMoney(cents, currency);
    });
  }

  var reconciling = false;
  async function reconcile() {
    if (reconciling) return;
    reconciling = true;
    try {
      var r = await fetch('/cart.js?kuvr_ts=' + Date.now(), { cache: 'no-store' });
      if (r.status !== 200) return; // throttled or down — never make it worse
      var cart = await r.json();
      var realKeys = {};
      cart.items.forEach(function (i) { realKeys[i.key] = true; });

      var rows = Array.prototype.slice.call(document.querySelectorAll('[data-item-row]'));
      var seen = {};
      var removedGhosts = 0;
      rows.forEach(function (row) {
        var k = row.getAttribute('data-line');
        if (!k) return;
        if (!realKeys[k] || seen[k]) { row.remove(); removedGhosts++; return; } // ghost or duplicate render
        seen[k] = true;
      });

      // Rows the real cart has that the page does not: one guarded reload gets a
      // fresh render; if that render is stale too, the totals below still tell the truth.
      var missing = cart.items.some(function (i) { return !seen[i.key]; });
      if (missing && location.search.indexOf(RELOAD_FLAG) === -1) {
        var sep = location.search ? '&' : '?';
        location.replace(location.pathname + location.search + sep + RELOAD_FLAG + '=1');
        return;
      }

      setMoney('.cart-total-subtotal', cart.items_subtotal_price, cart.currency);
      setMoney('.cart-total-grandtotal', cart.total_price, cart.currency);
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      if (removedGhosts) {
        try { console.log('[kuvr-cart-truth] removed ' + removedGhosts + ' stale row(s); totals set from live cart'); } catch (e) {}
      }
    } catch (e) { /* display corrector must never break the page */ }
    finally { reconciling = false; }
  }

  reconcile();
  var n = 0;
  var iv = setInterval(function () { reconcile(); if (++n >= SETTLE_CHECKS) clearInterval(iv); }, CHECK_MS);
  // and after any in-page cart mutation the theme performs
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-remove], [data-cart-quantity]')) {
      setTimeout(reconcile, 2500);
      setTimeout(reconcile, 6000);
    }
  }, true);

  window.__kuvrCartTruth = { reconcile: reconcile, version: 1 };
})();
